"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabLayout = void 0;
const react_1 = __importStar(require("react"));
const FrameContext_1 = require("../context/FrameContext");
const Sidebar_1 = require("./Sidebar");
const Header_1 = require("./Header");
const Spinner_1 = __importDefault(require("../../../components/loading/Spinner"));
const TabFrame_1 = require("./TabFrame");
const SidebarPanel_1 = require("./SidebarPanel");
const BlockingModal_1 = require("./BlockingModal");
const SpotlightModal_1 = require("./SpotlightModal");
const hooks_1 = require("../../../util/hooks");
const lC = new FrameContext_1.WindowContext({ mode: 'left' });
const rC = new FrameContext_1.WindowContext({ mode: 'right' });
const TabLayout = function ({ header, init, preload, disableSideBar, tabRenderer, sideBar, tabs, globalRenderer, blockingModal, panel, spotlightProps, spotlightOpen, hotKeys, }) {
    const { tabsRight, tabsLeft, currentTabRight, currentTabLeft } = tabs;
    const tabLeft = tabsLeft[currentTabLeft];
    const tabRight = tabsRight[currentTabRight];
    const [error, setError] = (0, react_1.useState)(false);
    (0, hooks_1.useKeyListener)(hotKeys || []);
    (0, react_1.useEffect)(() => {
        if (!error && !init) {
            preload();
        }
    }, [error, init]);
    if (error) {
        return react_1.default.createElement("div", null, "Error loading translation");
    }
    if (!init) {
        return (react_1.default.createElement("div", { className: "tab-layout--root" },
            react_1.default.createElement(Header_1.Header, { tabs: {
                    setCurrentTab: () => { },
                    addTab: () => { },
                    closeTab: () => { },
                    error: () => { },
                    tabsLeft: [],
                    tabsRight: [],
                    currentTabLeft: 0,
                    currentTabRight: 0,
                }, prop: header }),
            react_1.default.createElement("div", { className: "main" },
                react_1.default.createElement("div", { className: "row" },
                    react_1.default.createElement(Spinner_1.default, null)))));
    }
    if (globalRenderer) {
        return (react_1.default.createElement("div", { className: "tab-layout--root" },
            blockingModal ? (react_1.default.createElement(BlockingModal_1.BlockingModal, { message: blockingModal.message, progress: blockingModal.progress })) : null,
            spotlightOpen && spotlightProps ? (
            // eslint-disable-next-line react/jsx-props-no-spreading
            react_1.default.createElement(SpotlightModal_1.SpotlightModal, { ...spotlightProps })) : null,
            react_1.default.createElement(Header_1.Header, { tabs: tabs, prop: header }),
            react_1.default.createElement("div", { className: "main--sidebar" }, disableSideBar || !sideBar ? null : (react_1.default.createElement(Sidebar_1.Sidebar, { botMenu: sideBar.botMenu, topMenu: sideBar.topMenu, onClickItem: sideBar.onClickItem }))),
            globalRenderer()));
    }
    return (react_1.default.createElement("div", { className: "tab-layout--root" },
        blockingModal ? (react_1.default.createElement(BlockingModal_1.BlockingModal, { message: blockingModal.message, progress: blockingModal.progress })) : null,
        spotlightOpen && spotlightProps ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        react_1.default.createElement(SpotlightModal_1.SpotlightModal, { ...spotlightProps })) : null,
        react_1.default.createElement(Header_1.Header, { tabs: tabs, prop: header }),
        panel ? react_1.default.createElement(SidebarPanel_1.SidebarPanel, { c: panel }) : null,
        react_1.default.createElement("div", { className: "main--sidebar" }, disableSideBar || !sideBar ? null : (react_1.default.createElement(Sidebar_1.Sidebar, { botMenu: sideBar.botMenu, topMenu: sideBar.topMenu, onClickItem: sideBar.onClickItem }))),
        react_1.default.createElement(FrameContext_1.FrameContext.Provider, { value: lC },
            react_1.default.createElement(TabFrame_1.TabFrame, { tab: tabLeft, classNameExtend: tabRight ? 'main-no--sidebar-half' : '', tabRenderer: (r, classNameExtend) => (react_1.default.createElement(react_1.default.Fragment, null, tabRenderer(r, lC, classNameExtend))) })),
        tabRight ? (react_1.default.createElement(FrameContext_1.FrameContext.Provider, { value: rC },
            react_1.default.createElement(TabFrame_1.TabFrame, { tab: tabRight, classNameExtend: tabRight ? 'main-no--sidebar-half' : '', tabRenderer: (r, classNameExtend) => (react_1.default.createElement(react_1.default.Fragment, null, tabRenderer(r, rC, classNameExtend))) }))) : null));
};
exports.TabLayout = TabLayout;
TabLayout.defaultProps = {
    disableSideBar: false,
    sideBar: undefined,
    globalRenderer: undefined,
    panel: undefined,
    blockingModal: undefined,
    spotlightOpen: undefined,
    spotlightProps: undefined,
    hotKeys: undefined,
};
